<template>
  <section id="accounts-login" :class="{ desktop: $isDesktop }">
    <section>
      <translate tag="h1"> Login </translate>
      <login-form :email="email" />
    </section>
    <new-user />
    <slot />
  </section>
</template>

<script setup lang="ts">
const { t } = useI18n()
const route = useRoute()

defineProps<{ email: string }>()

// Only add noindex when there are query parameters
const hasQuery = computed(() => Object.keys(route.query).length > 0)

// Reactive head; re-evaluates when `hasQuery` changes on navigation
useHead(() => ({
  title: t('Log in to your Pitchup.com account') as string,
  meta: [
    ...(hasQuery.value
      ? [
          {
            hid: 'robots',
            name: 'robots',
            content: 'noindex',
          },
        ]
      : []),
    {
      hid: 'description',
      name: 'description',
      property: 'og:description',
      content: t(
        'Log in or reset your password for your Pitchup.com account to view your bookings, add reviews and more. Google or Facebook login available.',
      ) as string,
    },
  ],
}))
</script>

<style scoped>
h1 {
  color: var(--colour-dark-blue);
  font-size: 1.25em;
  padding: 0 1.5em;
  margin: 0;
  text-align: center;
}
#accounts-login :deep(.reset-password .modal-container) {
  width: 94vw;
}

/* desktop & tablet */
#accounts-login.desktop {
  display: grid;
  grid-template-rows: auto;
  margin: 3em auto 12em;
  max-width: var(--legacy-page-width-max);
  width: 100%;
  font-size: inherit;
  gap: 2em;
  align-items: start;
  grid-template-columns: repeat(auto-fit, minmax(17em, 1fr));
}

#accounts-login.desktop :deep(.reset-password .modal-container) {
  left: 0;
  right: 0;
}

@media screen and (max-width: 768px) {
  #accounts-login.desktop {
    padding: var(--page-width-padding);
  }
}

.desktop h1 {
  font-size: 1.75em;
  padding: 0.8em 0 0 0.8em;
  margin: 0;
  text-align: left;
}

#accounts-login.desktop > .new-user {
  margin-top: 0;
  border: none;
  padding-bottom: 2em;
}

#accounts-login.desktop > section {
  border: 4px solid var(--colour-page-background);
  border-radius: 1em;
}
</style>
